<template>
  <div class="dft-attr_container">
    <h4 class="dft-header">顶部标题栏</h4>
    <!-- 商品 -->
    <div class="attr-item-box" v-for="(item, index) in value.attrsort" :key="index">
      
      <div class="attr-item-typestyle" v-if="item == 'a0'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="1">无标题</el-radio-button>
            <el-radio-button label="2">默认标题</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <!-- <div class="attr-item-typestyle" v-else-if="item == 'a1' && value.attr['a0'].value=='2'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-input v-model="value.attr[item].value"></el-input>
        </div>
      </div> -->
      <!-- <div class="attr-item-typestyle" v-else-if="item == 'a2' && value.attr['a0'].value=='1'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value">
          <el-radio-group v-model="value.attr[item].value" size="small">
            <el-radio-button label="1">颜色</el-radio-button>
            <el-radio-button label="2">图片</el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="attr-item-typestyle" v-else-if="['a3'].includes(item) && value.attr['a0'].value=='1' && value.attr['a2'].value=='1'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-on">{{ value.attr[item].showList[value.attr[item].value] || value.attr[item].value }}</div>
        <div class="attr-item-value">
          <div class="colorPicker">
            <el-button type="text" @click="value.attr[item].value = value.attr[item].default" class="resetBtn">重置</el-button>
            <el-color-picker v-model="value.attr[item].value" show-alpha></el-color-picker>
          </div>
        </div>
      </div>
      <div class="attr-item-typedata" v-else-if="item == 'a4' && value.attr['a0'].value=='1' && value.attr['a2'].value=='2'">
        <div class="attr-item-label">{{ value.attr[item].label }}</div>
        <div class="attr-item-value upimg">
          <div class="img_info">建议尺寸：375x850 像素，尺寸不匹配时，图片将被压缩或拉伸以铺满画面</div>
          <div class="ii-img-box">
            <el-image class="ii-img" :src="value.attr[item].value" fit="scale-down"></el-image>
            <div class="ii-img-btn">
              <el-upload
                class=""
                :action="$uploadURL"
                :show-file-list="false"
                :on-success="(res, file)=>{handleChangeUploadSuccess(res, file,value.attr[item])}"
                :before-upload="beforeUpload"
              >
                <div class="">
                  更换图片
                </div>
              </el-upload>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import addClassPage from '../addClassPage.vue'

export default {
  components: {
    draggable,
    addClassPage
  },
  props: {
    value: {
      type: [Object,Array],
      default: () => {
        return { attr: {}, attrsort: [] }
      }
    }
  },
  model: {
    prop: 'value',
    event: 'changes'
  },
  data () {
    return {
      showDialog: false,
      showClassDialog: false,
      showSKDialog: false,
      gprefresh: true,
      showClassIndex: 0,
      showSKIndex: 0,
      navigatelist: [],
      groupRight: {
        name: 'itxst2',
        pull: false, // 拖出
        put: false // 拖入
      },
      btnloading: false,
      // 模板默认数据-19
      assemblyAttr666: JSON.stringify(
            {
              attr: {
                a0: {
                  label: '模式',
                  value: '2',
                  showList: {
                    '1': '无标题',
                    '2': '默认标题'
                  },
                  key: 'goodsTag',
                  type: 'style',
                  tag: 'radio'
                },
                a1: {
                  label: '标题名称',
                  value: '个人中心',
                  type: 'data',
                },
                a2: {
                  label: '背景类型',
                  value: '1',
                  showList: {
                    '1': '颜色',
                    '2': '图片'
                  },
                  key: 'goodsTag',
                  type: 'style',
                  tag: 'radio'
                },
                a3: {
                  label: '背景颜色',
                  value: '#ffffff',
                  showList: {},
                  default: '#ffffff',
                  key: 'background',
                  type: 'style',
                  tag: 'ColorPicker'
                },
                a4: {
                  label: '背景图片',
                  value: '',
                  key: 'background',
                  type: 'data',
                  tag: 'upload'
                },
              },
              attrsort: [
                'a0', 'a1', 'a2', 'a3', 'a4',
              ]
            }
          )
    }
  },
  watch: {
    // value: {
    //   handler: function(newVal){
    //     if(newVal){
    //       this.$nextTick(() => {
    //         console.log('comp--D-ata',newVal)
    //       });

    //     }
    //   },
    //   deep: true
    // }
  },
  computed: {
    // 分类
    classType () {
      return this.value?.attr?.['a0']?.value
    },
  },
  created () {
  },

  mounted () {
    this.$nextTick(() => {
      // console.log('comp--D-ata',this.value)
    })
  },

  methods: {
    initData () {
    },
    // 修改图片上传成功处理
    handleChangeUploadSuccess (res, file, ii) {
      const _imgUrl = file.response.data.url
      ii.value = _imgUrl
    },
    // 图片上传之前处理
    beforeUpload (file) {
      // const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isLt2M) {
      //   this.$message.error("上传图片大小不能超过 2MB!");
      // }
      // return  isLt2M;
    }
  }
}
</script>

<style lang="scss" scoped>
// @import url(../storecommonattr.less);
.dft-attr_container {
    width: 100%;
    box-sizing: border-box;
    padding: 8px;
  }

  .dft-header {
    margin: 5px 0;
  }
  .img_info {
    color: #969799;
    font-weight: 400;
    margin-top: 8px;
    white-space: pre-wrap;
    font-size: 13px;
  }
  .ii-img-box{
    margin-top: 8px;
    width: 150px;
    height: 90px;
    position: relative;
    .ii-img{
      width: 100%;
      height: 100%;
    }
    .ii-img-btn{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 30px;
      line-height: 30px;
      background-color: rgba($color: #000000, $alpha: .4);
      text-align: center;
      font-size: 13px;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .attr-item-box {
    // padding: 6px 6px;
    margin-bottom: 10px;
    .attr-item-typedata {
      margin: 6px 10px;

      .attr-item-label {
        margin-bottom: 5px;
        font-size: 14px;
      }

      .attr-item-value {
        .temp-box {
          display: flex;
          flex-wrap: wrap;

          .temp-item {
            width: calc((100% - 36px)/6);
            height: 90px;
            margin: 0 3px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            .temp-item-img {
              width: 48px;
              height: 48px;
              margin-bottom: 8px;
            }

            .temp-item-name {
              font-weight: 400;
              font-size: 11px;
              line-height: 20px;
              text-align: center;
              color: #333;

              .mini_span {
                /*transform: scale(.7);*/
              }
            }
          }

          .active_temp-item {
            .temp-item-name {
              color: #155bd4;
            }
          }
        }
      }
    }

    .attr-item-typestyle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      margin-bottom: 10px;
      margin: 6px 10px;

      .attr-item-label {
        color: #969799;
        margin-right: 12px;
      }

      .attr-item-on {
        color: #333333;
        margin-right: 8px;
        font-size: 12px;
      }

      .attr-item-value {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        align-items: center;
      }
    }

  }

  .colorPicker {
    height: 40px;
    display: flex;
    align-items: center;
  }

  .custon_slider {
    width: 100%;

    /deep/.el-slider__input {
      width: 60px;
    }

    /deep/.el-slider__runway.show-input {
      margin-left: 8px;
      margin-right: 80px;
    }
  }

  .btn-icon {
    line-height: 20px;
    color: #f44;
  }

  .select-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .select-btn {
    height: 18px;
    padding: 0 8px;
  }

  .info-set {
    position: absolute;
    bottom: 0;
    left: 0;
    color: #969799;
    font-size: 12px;
  }
.upimg{
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
